<template>
  <div class="container">
    <div class="top">

      <div class="top-content">
        <div class="top-left algin-class">{{ language['ipsys.createBy'] }}</div>
        <div class="top-right top-right-algin">{{model.userRealName}} </div>
      </div>
      <div class="top-content">
        <div class="top-left algin-class">{{ language['column.jobNumber'] }}</div>
        <div class="top-right top-right-algin">{{model.userWorkNo}} </div>
      </div>
      <div class="top-content">
        <div class="top-left algin-class">{{language['portal.front.factory']}}</div>
        <div class="top-right top-right-algin">{{model.userFactory}} </div>
      </div>
      <div class="top-content">
        <div class="top-left algin-class">{{language['esg.unit']}}</div>
        <div class="top-right top-right-algin">{{model.userDepartName}} </div>
      </div>
      <div class="top-content">
        <div class="top-left algin-class">{{language['hhemp.extension']}}</div>
        <div class="top-right top-right-algin">{{model.userTelephone}} </div>
      </div>
      <div class="top-content">
        <div class="top-left algin-class">{{language['column.mailbox']}}</div>
        <div class="top-right top-right-algin">{{model.userMail}} </div>
      </div>
      <div class="top-content">
        <div class="top-left algin-class">{{ language['hhemp.position'] }}</div>
        <div class="top-right top-right-algin">{{model.userEmpClass}} </div>
      </div>
      <div class="top-content">
        <div class="top-left algin-class">{{language['ipsys.createTime']}}</div>
        <div class="top-right top-right-algin">{{model.createTime}} </div>
      </div>
      <div class="top-content">
        <div class="top-left algin-class">{{language['hhemp.question.type']}}</div>
        <div class="top-right top-right-algin">{{feedbackTypeName}} </div>
      </div>
      <div class="top-content">
        <div class="top-left algin-class">{{language['ipsys.titie']}}</div>
        <div class="top-right top-right-algin">{{model.title}} </div>
      </div>
      <div class="top-content">
        <div class="top-left algin-class">{{language['announcement.msgContent']}}</div>
        <div class="top-right top-right-algin">{{model.content}} </div>
      </div>
    </div>

    <div class="buttom" v-if="handleType=='processed'&&model.status=='0'">
       <a-textarea  rows="8"  :placeholder="language['hhemp.input.suggestions']" v-model="model.processedOpinions"></a-textarea>
    </div>

    <div class="processed" v-if="model.status=='1'">
      <div class="top-content">
        <div class="top-left algin-class algin-class-processed">{{ language['portal.ui2.processStatus'] }}</div>
        <div class="top-right top-right-algin">{{ language['web.processed'] }} </div>
      </div>
      <div class="top-content">
        <div class="top-left algin-class algin-class-processed">{{language['sweep_handleDate']}}</div>
        <div class="top-right top-right-algin ">{{model.processedTime}} </div>
      </div>
      <div class="top-content">
        <div class="top-left algin-class algin-class-processed">{{language['sweep_handleName']}}</div>
        <div class="top-right top-right-algin ">{{model.processedName}} </div>
      </div>
      <div class="top-content">
        <div class="top-left algin-class algin-class-processed">{{language['hhemp.processing.suggestions']}}</div>
        <div class="top-right top-right-algin ">{{model.processedOpinions}} </div>
      </div>
    </div>

    <div class="source" v-if="model.status=='1'&&model.scoreStatus=='1'">
      <div class="top-content ">
        <div class="top-left algin-class algin-class-processed source-class">{{language['hhemp.satisfaction']}}</div>
        <div class="top-right top-right-algin"><a-rate :default-value="model.score" disabled />({{language['hhemp.rated']}}) </div>
      </div>
      <div class="top-content">
        <div class="top-left algin-class algin-class-processed source-class">{{language['hhemp.scoring.opinions']}}</div>
        <div class="top-right top-right-algin ">{{model.scoreOpinions}} </div>
      </div>
    </div>

  </div>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import JEditor from '@/components/jeecg/JEditor'
  import LanguageModel from "@/components/LanguageModel"
  import {  getDictItemsFromCache } from '@/api/api'
  import { filterDictText } from '@/components/dict/JDictSelectUtil'
  export default {
    name: 'CmsBannerForm',
    components: {
      JEditor,
      LanguageModel
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
        colidProps: String,
    },
    data () {
      const { language } = this.$store.getters;
      return language &&  {
        isDisable:false,
        value:"222",
        model:{
            // cnData:{content:""},
            // twData:{content:""},
            // enData:{content:""}
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        handleType:"",
        feedbackTypeList:[],
        feedbackTypeName:""
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      language() {
        return this.$store.getters.language
      },
    },
    created () {
      this.feedbackTypeList = getDictItemsFromCache('emp_freeback_type')
    },
    methods: {
      add () {
        //this.edit(this.modelDefault);
        this.edit({status:'0',linkType:"0"});
        this.colVisible = false;
      },
      edit (record) {
       // console.log("record.flag:",record.flag)
        this.handleType=record.flag;
        this.model = Object.assign({}, record);
        this.visible = true;
        this.feedbackTypeName= filterDictText(this.feedbackTypeList,  this.model.feedbackType)

      },
      submitForm () {
            let that=this;
            if(this.model.processedOpinions==null||this.model.processedOpinions==''){
              that.$message.warning(this.language['hhemp.input.suggestions']);
              return ;
            }
            let httpurl="/hhemp/feedback/processed";
            httpAction(httpurl, {id:this.model.id,processedOpinions:this.model.processedOpinions},"post").then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

    }
  }
</script>
<style scoped lang="less">
  .upload-class{
    margin-top: 20px;
  }
  .container{
    width: 100%;
    height: 100%;
    //border: red 1px solid;
  }
  //.top{
  //  display: flex;
  //  flex-direction: initial;
  //}
  .top-content{
    display: flex;
    flex-direction: initial;
    border: 1px #d7d7d7 solid;
  }
.top-left{
  width: 40%;
  background: #169bd5;
  color: #FFFFFF;
  min-height: 40px
}
.top-right{
  width: 100%;
}
.buttom{
  margin-top: 30px;
}
.hr-class{
  margin: 0.1px;
}
.algin-class{
  display: flex;
  justify-content: center;
  align-items: center;
}
.top-right-algin{
  display: flex;
  align-items: center;
  margin-left: 1%;
}
.processed{
  margin-top: 5%;
}
.algin-class-processed{
  background: #ff9900;
}
.source{
  margin-top: 5%;
}
.source-class{
  background:#379db4;
}
</style>
